import React, { useState } from 'react';
import { StatusBanca, TipoBancaNome } from '../../../model/banca/Banca';
import { toast } from 'react-toastify';
import { ComunicacaoMembroViewModel } from '../../../viewmodel/banca/ComunicacaoMembro/ComunicacaoMembroViewModel';
import BackendErrorMessage from '../../../components/BackendErrorMessage';
import { FaGavel, FaDesktop } from 'react-icons/fa';
import { BsFilePerson } from 'react-icons/bs';
import { format, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import AnimatedModal from './AnimatedModal';
import ModalHelp from '../../../components/ModalHelp';

interface ConvocarBancaModalProps {
  banca: any;
  onClose: () => void;
  onConvocacaoSucesso: (bancaAtualizada: any) => void;
}

const ConvocarBancaModal: React.FC<ConvocarBancaModalProps> = ({ 
  banca, 
  onClose, 
  onConvocacaoSucesso 
}) => {
  const [loading, setLoading] = useState(false);

  const getTipoBancaIcon = (tipoBanca: string) => {
    switch (tipoBanca) {
      case TipoBancaNome.FACIAL:
        return <BsFilePerson style={{ fontSize: '16px', color: '#2F4F4F' }} />;
      case TipoBancaNome.RECURSAL:
        return <FaGavel style={{ fontSize: '16px', color: '#2F4F4F' }} />;
      case TipoBancaNome.VIRTUAL:
        return <FaDesktop style={{ fontSize: '16px', color: '#2F4F4F' }} />;
      default:
        return null;
    }
  };

  const handleConfirmar = async () => {
    setLoading(true);
    try {
      const response = await ComunicacaoMembroViewModel.convocaBanca(banca.id);
      if (response.status >= 200 && response.status < 300) {
        toast.success('Banca convocada.');
        onConvocacaoSucesso({ ...banca, status: StatusBanca.CONVOCADA });
        onClose();
      } else {
        toast.error('Erro na convocação. Tente novamente.');
      }
    } catch (error) {
      console.error('Erro na convocação:', error);
      toast.error(BackendErrorMessage(error));
    } finally {
      setLoading(false);
    }
  };

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <AnimatedModal isOpen={true} onClose={onClose}>
      <div style={{
        backgroundColor: 'white',
        padding: '30px',
        borderRadius: '8px',
        width: '400px',
        maxWidth: '90vw'
      }}>
        <h3 style={{ marginBottom: '20px', textAlign: 'center' }}>
          Convocar Banca
        <ModalHelp text="Ao confirmar, emails de convocação serão enviados para todos os membros definidos. A banca mudará para status Convocada." />
        </h3>
        
        <div style={{
          backgroundColor: '#f8f9fa',
          padding: '15px',
          borderRadius: '6px',
          marginBottom: '20px',
          border: '1px solid #e9ecef'
        }}>
          <div style={{ marginBottom: '8px' }}>
            <strong>Data:</strong> {banca.dataDeBanca?.data ? format(parseISO(banca.dataDeBanca.data), 'dd/MM/yyyy', { locale: ptBR }) : 'Não definida'}
          </div>
          <div style={{ marginBottom: '8px' }}>
            <strong>Horário:</strong> {banca.dataDeBanca?.horaInicial && banca.dataDeBanca?.horaFinal 
              ? `${banca.dataDeBanca.horaInicial.slice(0, 5)}-${banca.dataDeBanca.horaFinal.slice(0, 5)}` 
              : 'Não definido'}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <strong>Tipo:</strong> 
            {getTipoBancaIcon(banca.tipoBanca?.nome)}
            {banca.tipoBanca?.nome}
          </div>
        </div>
        
        <div style={{ 
          marginBottom: '20px', 
          textAlign: 'center',
          fontWeight: 'bold',
          fontSize: '16px'
        }}>
          Confirma a convocação desta Banca?
        </div>

        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
          <button
            type="button"
            onClick={onClose}
            style={{
              padding: '8px 16px',
              border: '1px solid #ddd',
              background: 'white',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
            disabled={loading}
          >
            Cancelar
          </button>
          <button
            onClick={handleConfirmar}
            style={{
              padding: '8px 16px',
              backgroundColor: '#28a745',
              color: 'white',
              border: '1px solid #28a745',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
            disabled={loading}
          >
            {loading ? 'Convocando...' : 'Convocar'}
          </button>
        </div>
      </div>
    </AnimatedModal>
  );
};

export default ConvocarBancaModal;